import type { StatefulDiaryT, StatefulTrackerViewT } from "@patient-watch/types";

export function extractTrackerById(diary: StatefulDiaryT, trackerId: string) {
    return diary?.trackers_view?.find((m) => m.tracker_id === trackerId) as StatefulTrackerViewT;
}
